import { EOfficeType, Filters } from 'shared/types/filters';

export function hasBusinessOfficeType(filters: Filters): boolean {
  return filters.officeType.some(type => [EOfficeType.RentalBusiness, EOfficeType.ReadyBusiness].includes(type));
}
